import React from "react";
import { Link } from "gatsby";
import styled from "@emotion/styled";

export default class IndicationsBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeStep: 0, zone: "visage", indication: "effacer-rides" };
    this.changeStep = this.changeStep.bind(this);
    this.changeZone = this.changeZone.bind(this);
    this.changeIndication = this.changeIndication.bind(this);
  }

  changeStep(newStep) {
    this.setState({ activeStep: newStep });
  }

  changeZone(newZone) {
    this.setState({ zone: newZone, activeStep: 1 });
  }

  changeIndication(newIndication) {
    this.setState({ indication: newIndication, activeStep: 2 });
  }

  render() {
    return (
      <div>
        <MultiStep>
          {this.state.activeStep === 0 && (
            <Wrapper>
              <Step>
                <StepNumber>Étape 1/3</StepNumber>
                Sélectionnez une région du corps
              </Step>

              <CardWrapper>
                <Card onClick={() => this.changeZone("visage")}>
                  <Img
                    src="/visage.jpg"
                    alt="Traitements esthétique du visage"
                  />
                  <CardTitle>Visage</CardTitle>
                </Card>
                <Card onClick={() => this.changeZone("regard")}>
                  <Img
                    src="/regard.jpg"
                    alt="Traitements esthétique du regard"
                  />
                  <CardTitle>Regard</CardTitle>
                </Card>
                <Card onClick={() => this.changeZone("nez")}>
                  <Img src="/nez.jpg" alt="Traitements esthétique du nez " />
                  <CardTitle>Nez</CardTitle>
                </Card>
                <Card onClick={() => this.changeZone("oreilles")}>
                  <Img
                    src="/oreilles.jpg"
                    alt="Traitements esthétique des oreilles "
                  />
                  <CardTitle>Oreilles</CardTitle>
                </Card>
                <Card onClick={() => this.changeZone("seins")}>
                  <Img
                    src="/seins.jpg"
                    alt="Traitements esthétique des seins"
                  />
                  <CardTitle>Seins</CardTitle>
                </Card>
                <Card onClick={() => this.changeZone("silhouette")}>
                  <Img
                    src="/silhouette.jpg"
                    alt="Traitements esthétique de la silhouette"
                  />
                  <CardTitle>Silhouette</CardTitle>
                </Card>
                <Card onClick={() => this.changeZone("jambes")}>
                  <Img
                    src="/jambes.jpg"
                    alt="Traitements esthétique des jambes"
                  />
                  <CardTitle>Jambes</CardTitle>
                </Card>
                <Card onClick={() => this.changeZone("peau")}>
                  <Img
                    src="/peau.jpg"
                    alt="Traitements esthétique de la peau"
                  />
                  <CardTitle>Peau</CardTitle>
                </Card>
              </CardWrapper>
            </Wrapper>
          )}

          {this.state.activeStep === 1 && (
            <Wrapper>
              <Step>
                <StepNumber>Étape 2/3</StepNumber>
                Sélectionnez une indication
              </Step>

              {this.state.zone === "visage" && (
                <div>
                  <CardWrapper>
                    <Card
                      onClick={() => this.changeIndication("effacer-rides")}
                    >
                      <Img
                        src="/effacer-rides.jpg"
                        alt="Effacer les rides et ridules du visage"
                      />
                      <CardTitle>
                        Effacer les rides et ridules du visage
                      </CardTitle>
                    </Card>

                    <Card
                      onClick={() => this.changeIndication("restaurer-volumes")}
                    >
                      <Img
                        src="/restaurer-volumes.jpg"
                        alt="Restaurer les volumes de mon visage"
                      />
                      <CardTitle>Restaurer les volumes de mon visage</CardTitle>
                    </Card>

                    <Card
                      onClick={() =>
                        this.changeIndication("supprimer-imperfections")
                      }
                    >
                      <Img
                        src="/peau.jpg"
                        alt="Supprimer les imperfections cutanées"
                      />
                      <CardTitle>
                        Supprimer les imperfections cutanées
                      </CardTitle>
                    </Card>

                    <Card
                      onClick={() => this.changeIndication("rajeunir-peau")}
                    >
                      <Img
                        src="/rajeunir-peau.jpg"
                        alt="Rajeunir la peau de mon visage"
                      />
                      <CardTitle>Rajeunir la peau de mon visage</CardTitle>
                    </Card>
                  </CardWrapper>
                </div>
              )}

              {this.state.zone === "regard" && (
                <div>
                  <CardWrapper>
                    <Card
                      onClick={() =>
                        this.changeIndication("modifier-forme-paupieres")
                      }
                    >
                      <Img
                        src="/modifier-forme-paupieres.jpg"
                        alt="Modifier la forme de mes paupières"
                      />
                      <CardTitle>Modifier la forme de mes paupières</CardTitle>
                    </Card>

                    <Card
                      onClick={() => this.changeIndication("tiers-superieur")}
                    >
                      <Img
                        src="/tiers-superieur.jpg"
                        alt="Rajeunir le tiers supérieur du visage"
                      />
                      <CardTitle>
                        Rajeunir le tiers supérieur du visage
                      </CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("cernes")}>
                      <Img src="/cernes.jpg" alt="J'ai des cernes" />
                      <CardTitle>J'ai des cernes</CardTitle>
                    </Card>
                  </CardWrapper>
                </div>
              )}

              {this.state.zone === "nez" && (
                <div>
                  <CardWrapper>
                    <Card onClick={() => this.changeIndication("forme-nez")}>
                      <Img
                        src="/forme-nez.jpg"
                        alt="Modifier la forme de mon nez"
                      />
                      <CardTitle>Modifier la forme de mon nez</CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("respirer")}>
                      <Img
                        src="/respirer.jpg"
                        alt="J’ai des difficultés à respirer"
                      />
                      <CardTitle>J’ai des difficultés à respirer...</CardTitle>
                    </Card>
                  </CardWrapper>
                </div>
              )}

              {this.state.zone === "oreilles" && (
                <div>
                  <CardWrapper>
                    <Card
                      onClick={() =>
                        this.changeIndication("oreilles-decollees")
                      }
                    >
                      <Img
                        src="/oreilles-decollees.jpg"
                        alt="Mes oreilles sont décollées"
                      />
                      <CardTitle>Mes oreilles sont décollées</CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("lobes")}>
                      <Img src="/lobes.jpg" alt="Mes lobes sont abîmés" />
                      <CardTitle>Mes lobes sont abîmés</CardTitle>
                    </Card>
                  </CardWrapper>
                </div>
              )}

              {this.state.zone === "seins" && (
                <div>
                  <CardWrapper>
                    <Card onClick={() => this.changeIndication("trop-petite")}>
                      <Img
                        src="/trop-petite.jpg"
                        alt="Ma poitrine est trop petite"
                      />
                      <CardTitle>Ma poitrine est trop petite</CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("tombante")}>
                      <Img src="/tombante.jpg" alt="Ma poitrine est tombante" />
                      <CardTitle>Ma poitrine est tombante</CardTitle>
                    </Card>

                    <Card
                      onClick={() => this.changeIndication("reconstruction")}
                    >
                      <Img
                        src="/reconstruction.jpg"
                        alt="Ma poitrine doit être reconstruite"
                      />
                      <CardTitle>Ma poitrine doit être reconstruite</CardTitle>
                    </Card>
                  </CardWrapper>
                </div>
              )}

              {this.state.zone === "silhouette" && (
                <div>
                  <CardWrapper>
                    <Card
                      onClick={() =>
                        this.changeIndication("redessiner-sa-silhouette")
                      }
                    >
                      <Img
                        src="/redessiner-sa-silhouette.jpg"
                        alt="Redessiner sa silhouette"
                      />
                      <CardTitle>Redessiner sa silhouette</CardTitle>
                    </Card>

                    <Card
                      onClick={() =>
                        this.changeIndication("perdre-masse-graisseuse")
                      }
                    >
                      <Img
                        src="/perdre-masse-graisseuse.jpg"
                        alt="Perdre de la masse graisseuse"
                      />
                      <CardTitle>Perdre de la masse graisseuse</CardTitle>
                    </Card>
                  </CardWrapper>
                </div>
              )}

              {this.state.zone === "jambes" && (
                <div>
                  <CardWrapper>
                    <Card
                      onClick={() => this.changeIndication("affiner-jambes")}
                    >
                      <Img src="/affiner-jambes.jpg" alt="Affiner mes jambes" />
                      <CardTitle>Affiner mes jambes</CardTitle>
                    </Card>

                    <Card
                      onClick={() => this.changeIndication("sculpter-jambes")}
                    >
                      <Img
                        src="/sculpter-jambes.jpg"
                        alt="Sculpter mes jambes"
                      />
                      <CardTitle>Sculpter mes jambes</CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("cellulite")}>
                      <Img src="/cellulite.jpg" alt="Éliminer la cellulite" />
                      <CardTitle>Éliminer la cellulite</CardTitle>
                    </Card>
                  </CardWrapper>
                </div>
              )}

              {this.state.zone === "peau" && (
                <div>
                  <CardWrapper>
                    <Card onClick={() => this.changeIndication("terne")}>
                      <Img
                        src="/terne.jpg"
                        alt="Ma peau est terne et fatiguée"
                      />
                      <CardTitle>Ma peau est terne et fatiguée</CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("relachee")}>
                      <Img src="/relachee.jpg" alt="Ma peau est relâchée" />
                      <CardTitle>Ma peau est relâchée</CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("rides")}>
                      <Img src="/rides.jpg" alt="Ma peau est ridée" />
                      <CardTitle>Ma peau est ridée</CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("cicatrices")}>
                      <Img
                        src="/cicatrices.jpg"
                        alt="J’ai des cicatrices ou des séquelles d’acné"
                      />
                      <CardTitle>
                        J’ai des cicatrices ou des séquelles d’acné
                      </CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("taches")}>
                      <Img
                        src="/taches.jpg"
                        alt="J’ai des tâches ou des lésions pigmentaires"
                      />
                      <CardTitle>
                        J’ai des tâches ou des lésions pigmentaires
                      </CardTitle>
                    </Card>
                  </CardWrapper>
                  <p>&nbsp;</p>
                </div>
              )}
              <Back onClick={() => this.changeStep(0)}>&lt; Retour</Back>
            </Wrapper>
          )}

          {this.state.activeStep === 2 && (
            <Wrapper>
              <Step>
                <StepNumber>Étape 3/3</StepNumber>
                Traitements indiqués à vos attentes
              </Step>

              {this.state.indication === "effacer-rides" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/effacer-rides.jpg" alt="Effacer les rides" />
                  </IndicationImage>

                  <Indication>
                    <H3>Effacer les rides</H3>
                    <P>
                      Les techniques de médecine et de chirurgie esthétique
                      proposent plusieurs types de traitements qui ont fait leur
                      preuve dans la suppression ou l’atténuation des rides et
                      ridules.
                    </P>
                    <P>
                      Dans le domaine de la médecine esthétique, on trouve
                      notamment l’injection de produits de comblement (acide
                      hyaluronique), l’inhibition de certains muscles à
                      l’origine des rides d’expression (botox) ou stimulation de
                      la collagènese par l’organisme offerte par laser ou
                      Keybody-Skin.
                    </P>
                    <P>
                      Dans le domaine de la chirurgie esthétique, les liftings
                      (notamment le lifting du visage LVPA pratiqué par le Dr
                      Cédric Kron) corrigent les rides en remettant en tension
                      la peau.
                    </P>
                    <FlexIndication>
                      <Half>
                        <H4>Traitement médicaux</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/acide-hyaluronique/">
                              Acide hyaluronique
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/comblement-rides-front/">
                              Comblement des rides du front
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/fils-tenseurs-silhouette-soft/">
                              Fils tenseurs
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/botox/">
                              Injections de botox
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/regard/patte-d-oie-botox/">
                              Supprimer les rides de la patte d’oie
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Traitement chirurgicaux</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/visage/lifting-cervico-facial/">
                              Lifting cervico-facial
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/regard/lifting-du-front/">
                              Lifting du front
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/lifting-visage-paris/">
                              Lifting du visage LVPA
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/cernes/lifting-malaire-cernes-creux/">
                              Lifting malaire
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "restaurer-volumes" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/restaurer-volumes.jpg"
                      alt="Restaurer les volumes de mon visage"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Restaurer les volumes de mon visage</H3>
                    <P>
                      La perte des volumes du visage s’explique principalement
                      par le phénomène naturel du vieillissement cutané. Avec
                      l’âge, et notamment à la ménopause, le niveau d’hormones
                      diminue ce qui entraine une production moins importante
                      des cellules indispensables au «&nbsp;remplissage&nbsp;»
                      de la peau et responsables de son aspect lisse et ferme.
                    </P>
                    <P>
                      Pour qualifier ce phénomène de perte des volumes du
                      visage, on parle parfois d’affaissement de la peau, de
                      perte de la densité du visage ou de perte des contours du
                      visage. Il existe des techniques médicales et
                      chirurgicales qui permettent de restaurer naturellement et
                      durablement ces volumes.
                      <br />
                      &nbsp;
                    </P>

                    <FlexIndication>
                      <Half>
                        <H4>Traitement médicaux</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/acide-hyaluronique/">
                              Acide hyaluronique
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/ellanse/">
                              ELLANSÉ®
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/fils-tenseurs-silhouette-soft/">
                              Fils tenseurs
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/phototherapie-dynamique/">
                              Photothérapie dynamique
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/rajeunissement-cou-botox/">
                              Rajeunissement du cou (botox)
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/reduction-machoire-botox/">
                              Réduction de la mâchoire
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/traitement-esthetique-levres/">
                              Repulper les lèvres (acide hyaluronique)
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/supprimer-bajoues/">
                              Supprimer les bajoues
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Traitement chirurgicaux</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/visage/genioplastie/">
                              Genioplastie
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/lifting-cervico-facial/">
                              Lifting cervico-facial
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/lifting-visage-paris/">
                              Lifting du visage LVPA
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/cernes/lifting-malaire-cernes-creux/">
                              Lifting malaire
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/supprimer-double-menton/">
                              Lipoaspiration du menton
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/traitement-esthetique-levres/">
                              Lipostructure des lèvres
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "supprimer-imperfections" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/peau.jpg"
                      alt="Supprimer les imperfections cutanées"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Supprimer les imperfections cutanées</H3>
                    <P>
                      Depuis plusieurs années, les nouvelles techniques de
                      médecine esthétique ont permis une meilleure prise en
                      charge des imperfections cutanées : les résultats sont
                      plus significatifs, les séances plus confortables et les
                      effets secondaires plus faibles.
                    </P>
                    <P>
                      Parmi les imperfections de la peau qui peuvent être
                      atténuer par la médecine esthétique, on trouve notamment
                      les vergetures, les pores dilatés, lestâches solaires
                      (lentigo), la couperose, la rosacée, l'erythrose, les
                      éphélides, les grains de Milium ainsi que les séquelles
                      d’acné et de varicelles.
                    </P>
                    <Plus>En savoir plus&nbsp;:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/visage/couperose-rosacee-erythrose-laser/">
                              Couperose, rosacée, erythrose
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/carboxytherapie/">
                              Carboxythérapie du visage
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/hydrafacial/">
                              HydraFacial
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/mesolift-nctf/">
                              Mesolift NCTF
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/visage/peeling-combine/">
                              Peeling combiné
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/peeling-bioretivalisant-prx-t33/">
                              Peeling biorevitalisant
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/skinbooster/">
                              Skinbooster
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/universkin/">
                              Universkin
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "rajeunir-peau" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/rajeunir-peau.jpg"
                      alt="Rajeunir la peau de mon visage"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Rajeunir la peau de mon visage</H3>
                    <P>
                      Les techniques de médecine esthétique permettant de
                      prendre en charge le vieillissement de la peau du visage
                      sont particulièrement efficaces pour corriger les rides,
                      le relâchement cutané, perte de volume ou déficit
                      d’hydratation.
                    </P>
                    <P>
                      Pour vous accompagner dans le traitement des signes du
                      vieillissement au niveau du visage, le Dr Kron et son
                      équipe ont mis en place une pré-consultation diagnostic
                      visage dont l’objectif est de vous informer en fonction de
                      votre demande et de votre anatomie de façon à mettre en
                      place un protocole thérapeutique sur-mesure et une prise
                      en charge globale du rajeunissement de votre visage.
                    </P>
                    <Plus>En savoir plus&nbsp;:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/visage/carboxytherapie/">
                              Carboxythérapie du visage
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/ellanse/">
                              ELLANSÉ®
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/hydrafacial/">
                              HydraFacial
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/mesolift-nctf/">
                              Mesolift NCTF
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/visage/peeling-combine/">
                              Peeling combiné
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/peeling-bioretivalisant-prx-t33/">
                              Peeling biorevitalisant
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/skinbooster/">
                              Skinbooster
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/universkin/">
                              Universkin
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "modifier-forme-paupieres" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/modifier-forme-paupieres.jpg"
                      alt="Modifier la forme de mes paupières"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Modifier la forme de mes paupières</H3>
                    <P>
                      Une blépharoplastie est une intervention de chirurgie
                      esthétique des paupières visant à embellir le regard en
                      supprimant les disgrâces au niveau des paupières. Il
                      s'agit notamment de disgrâces causées par l'âge comme les
                      rides du contours des yeux ou des poches/cernes pleins.
                    </P>
                    <P>
                      Une chirurgie des paupière peut également concerner des
                      patients plus jeunes qui cherchent à modifier la forme
                      initiale de leurs paupières (cerne congénital, paupière
                      asiatique ou eurasienne). Dans le cas de la
                      blépharoplastie asiatique, l’objectif est moins
                      d’occidentaliser le regard que de l’embellir, de faire des
                      yeux plus en amande ou un regard plus ouvert.
                    </P>
                    <Plus>En savoir plus&nbsp;:</Plus>

                    <FlexIndication>
                      <Ul>
                        <Li>
                          <StyledLink to="/regard/blepharoplastie-chirurgie-paupieres/">
                            Blépharoplastie
                          </StyledLink>
                        </Li>
                        <Li>
                          <StyledLink to="/regard/blepharoplastie-asiatique/">
                            Blépharoplastie asiatique
                          </StyledLink>
                        </Li>
                        <Li>
                          <StyledLink to="/regard/plexr/">Plexr</StyledLink>
                        </Li>
                      </Ul>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "tiers-superieur" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/tiers-superieur.jpg"
                      alt="Rajeunir le tiers supérieur du visage"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Rajeunir le tiers supérieur du visage</H3>
                    <P>
                      Le vieillissement du tiers supérieur du visage est causé
                      par trois phénomènes naturels : l’effet de la pesanteur,
                      l’action du muscle frontal à l’origine des rides
                      transversales et l’action des muscles qui entrainent
                      l’apparition de sillons verticaux (rides du lion).
                    </P>
                    <P>
                      Les traitements esthétiques de chirurgie ou de médecine
                      tels que le lifting, le peeling, l’injection de Botox ou
                      d’acide hyaluronique permettent de rajeunir le tiers
                      supérieur du visage en retendant la peau, en atténuant les
                      rides du front et du lion.
                      <br />
                      &nbsp;
                    </P>

                    <FlexIndication>
                      <Half>
                        <H4>Traitement médicaux</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/visage/carboxytherapie/">
                              Carboxythérapie du visage
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/hydrafacial/">
                              HydraFacial
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/mesolift-nctf/">
                              Mesolift NCTF
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/peeling-combine/">
                              Peeling combiné
                            </StyledLink>
                          </Li>

                          <Li>
                            <StyledLink to="/peau/peeling-bioretivalisant-prx-t33/">
                              Peeling biorevitalisant
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/skinbooster/">
                              Skinbooster
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/universkin/">
                              Universkin
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Traitement chirurgicaux</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/regard/lifting-du-front/">
                              Lifting du front
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/cernes/lifting-malaire-cernes-creux/">
                              Lifting malaire
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/lifting-visage-paris/">
                              Lifting du visage LVPA
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "cernes" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/cernes.jpg" alt="J’ai des cernes…" />
                  </IndicationImage>

                  <Indication>
                    <H3>J’ai des cernes…</H3>
                    <P>
                      Sous l’appellation générique de «&nbsp;cerne&nbsp;», on
                      désigne des indications différentes, pouvant être
                      associées, qui touchent la région du contour inférieur des
                      yeux.
                    </P>

                    <P>
                      Il existe différents types de cernes - cernes creux,
                      cernes colorés et cernes pleins (appelés parfois
                      «&nbsp;poches sous les yeux&nbsp;»)- pour lesquelles il
                      existe plusieurs techniques médicales et chirurgicales
                      pour préneir leur apparition et/ou les atténuer.
                    </P>

                    <Plus>En savoir plus&nbsp;:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/cernes/differents-types-de-cernes/">
                              Les différents types de cernes
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/cernes/lifting-malaire-cernes-creux/">
                              Chirurgie des cernes pleins et des poches
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/cernes/comblement-cernes-creux-acide-hyaluronique/">
                              Comblement des cernes creux
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/cernes/lifting-malaire-cernes-creux/">
                              Lifting malaire : Chirurgie des cernes creux
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/cernes/lipostructure-des-cernes/">
                              Lipostructure des cernes
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/cernes/peeling-depigmentant-cernes/">
                              Cernes marrons : Peeling depigmentant
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "forme-nez" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/forme-nez.jpg"
                      alt="Modifier la forme de mon nez"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Modifier la forme de mon nez</H3>
                    <P>
                      Le nez constitue un des éléments les plus importants de
                      l'harmonie d'un visage. C'est cette harmonie qui est à
                      l'origine de la séduction d'un visage et non pas la
                      juxtaposition d'éléments standardisés. Lors d'un
                      traitement de la forme du du nez, il est essentiel
                      d’éviter de tomber dans le stéréotype du nez « refait ».
                    </P>
                    <P>
                      Il existe plusieurs techniques de médecine (injection
                      d’acide hyaluronique) et de chirurgie esthétique du nez
                      (rhinoplastie, septoplastie) pour corriger son apparence
                      du nez et gommer certaines disgrâces, qu’elles soient
                      d’origine congénitale, consécutives à un traumatisme ou
                      causées par le vieillissement.
                      <br />
                      &nbsp;
                    </P>

                    <FlexIndication>
                      <Half>
                        <H4>Traitement chirurgical</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/nez/rhinoplastie/">
                              Rhinoplastie
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/nez/rhinoplastie-ethnique/">
                              Rhinoplastie ethnique
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/nez/rhinoplastie-medicale/">
                              Rhinoplastie secondaire
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Traitement médical</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/nez/rhinoplastie-medicale/">
                              Rhinoplastie médicale
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "respirer" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/respirer.jpg"
                      alt="J’ai des difficultés à respirer..."
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>J’ai des difficultés à respirer...</H3>
                    <P>
                      Une déviation de la cloison nasale est une déformation de
                      la paroi intérieure du nez. Cette déviation peut concerner
                      le cartilage ou les os du nez, ou les deux à la fois. Une
                      déviation de la cloison nasale peut être causée par une
                      malformation ou à un traumatisme du nez suite à un impact
                      ou un choc.
                    </P>
                    <P>
                      Une déviation de la cloison nasale peut impliquer des
                      problèmes d’ordre médical : obstruction nasale chronique,
                      une gêne respiratoire, des ronflements, voire des
                      infections des sinus et de l’oreille et parfois des
                      migraines. Une déviation de la cloison nasale peut
                      également provoquer une déformation inesthétique de la
                      forme du nez (le nez est partiellement dévié sur un côté).
                      &nbsp;
                    </P>
                    <Plus>En savoir plus&nbsp;:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/nez/septoplastie/">
                              Septoplastie : Déviation de la cloison nasale
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/nez/migraine-nasale/">
                              Traitement de la migraine par septoplastie
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/nez/rhinoplastie-secondaire/">
                              Rhinoplastie secondaire
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "oreilles-decollees" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/oreilles-decollees.jpg"
                      alt="Mes oreilles sont décollées"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Mes oreilles sont décollées</H3>
                    <P>
                      On peut considérer que des oreilles sont
                      «&nbsp;décollées&nbsp;» lorsque l’angle qu’elles forment
                      avec le crâne est supérieur à la moyenne et/ou lorsque la
                      conque n’est pas parallèle au crâne. Les oreilles sont
                      alors trop apparentes quand elles sont vues de face.
                    </P>
                    <P>
                      Une correction chirurgicale des oreilles décollées peut
                      être réalisés sur les adultes, les adolescents et les
                      enfants. Dans certaines conditions, une otoplastie peut
                      faire l'objet d'une prise en charge par la sécurité
                      sociale et les mutuelles santé.
                      <br />
                      &nbsp;
                    </P>

                    <FlexIndication>
                      <Half>
                        <H4>Traitement chirurgical</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/oreilles/oreilles-decollees/">
                              Otoplastie
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Traitement médical</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/oreilles/earfold-correction-oreilles-decollees/">
                              Implants Earfold
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "lobes" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/lobes.jpg" alt="Mes lobes sont abîmés" />
                  </IndicationImage>

                  <Indication>
                    <H3>Mes lobes sont abîmés</H3>
                    <P>
                      Le lobe d'oreille est la partie inférieure du pavillon de
                      l’oreille. Il est composé de tissu adipeux et ne contient
                      pas de cartilage. Le lobe est une partie du visage
                      particulièrement délicate et vulnérable. Elle est composée
                      d’une peau fragile ne bénéficiant pas du soutien du
                      cartilage – à la différence d’autres parties de l’oreille
                      externe.
                    </P>
                    <P>
                      Un traitement esthétique des lobes de l’oreille est
                      indiqué chez les patients gênés par l’apparence de leur
                      lobes (trop grands ou déformés) ainsi que ceux qui ont
                      connu une déchirure du lobe (lors d'un traumatisme) ou un
                      allongement du lobe suite au port de boucle d'oreilles
                      lourdes ou d'écarteurs.
                      <br />
                      &nbsp;
                    </P>
                    <Plus>En savoir plus&nbsp;:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/lobes-oreilles/">
                              Chirurgie des lobes fendus, déchirés ou allongés{" "}
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "trop-petite" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/trop-petite.jpg"
                      alt="Ma poitrine est trop petite"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Ma poitrine est trop petite</H3>
                    <P>
                      Dés votre adolescence, vous jugiez vos seins trop petits,
                      trop peu développés. Ils ne correspondaient pas à l'image
                      que vous vous faisiez de vous-même et de votre féminité.
                      Uune augmentation mammaire apparaît comme un moyen de
                      faire correspondre votre image de la féminité à votre
                      corps, de vous sentir plus femme.
                    </P>
                    <P>
                      Une augmentation mammaire peut églement accentuer la
                      féminité de votre silhouette, mettre davantage en valeur
                      vos seins pour vous sentir plus séductrice.
                      <br />
                      &nbsp;
                    </P>
                    <Plus>En savoir plus&nbsp;:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/seins/protheses-mammaires/">
                              Augmentation mammaire par prothèses
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/chirurgie-esthetique-sous-anesthesie-locale/#augmentation-mammaire">
                              Augmentation mammaire sous anesthésie locale
                            </StyledLink>
                          </Li>

                          <Li>
                            <StyledLink to="/seins/lipostructure/">
                              Lipostructure des seins
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "tombante" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/tombante.jpg" alt="Ma poitrine est tombante" />
                  </IndicationImage>

                  <Indication>
                    <H3>Ma poitrine est tombante</H3>
                    <P>
                      Après une grossesse ou un amaigrissement important, vous
                      avez vu vos seins se relâcher, perdre leur galbe et
                      s'aplatir. Vous ne vous reconnaissez plus avec cette
                      poitrine «&nbsp;tombante&nbsp;» qui ne correspond pas à
                      l'image que vous avez de vous. Vous souhaitez retrouver la
                      tonicité et le volume de votre poitrine d'avant (voir un
                      peu plus). Une chirurgie mammaire vous permettrait de vous
                      retrouver en tant que femme, en corrigeant les effets des
                      années passées.
                    </P>
                    <P>
                      Si le volume des seins est trop important par rapport au
                      reste du corps, il est possible d'avoir recours à une
                      réduction mammaire pour obtenir des seins harmonieux par
                      rapport à votre anatomie et qui correspondent à votre
                      désir.
                      <br />
                      &nbsp;
                    </P>
                    <Plus>En savoir plus&nbsp;:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/seins/rajeunissement-mammaire-correction-ptose/">
                              Correction de ptôse mammaire
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/mommy-makeover/">
                              Mommy Makeover
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/seins/rajeunissement-mammaire-correction-ptose/">
                              Rajeunissement des seins
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/seins/reduction-mammaire/">
                              Réduction mammaire
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "reconstruction" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/reconstruction.jpg"
                      alt="Ma poitrine doit être reconstruite"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Ma poitrine doit être reconstruite</H3>
                    <P>
                      Une reconstruction mammaire a pour but de reconstituer le
                      volume et les contenus du sein et de reconstruire l’aréole
                      et le mamelon. Le plus souvent, une première intervention
                      permet de recréer la forme et le volume du sein et une
                      seconde intervention permet la reconstruction de l’aréole
                      et du mamelon.
                    </P>
                    <P>
                      Certaines femmes ayant eu recours à une augmentation
                      mammaire peuvent décider à un moment de leur vie qu’elles
                      souhaitent retrouver leur poitrine initiale ou changer de
                      silhouette mammaire. Si une augmentation mammaire est une
                      chirurgie réversible et qu’un retrait d’implants permet
                      d’obtenir un résultat très naturel, il est important que
                      cette décision soit réfléchie et prise pour de bonnes
                      raisons &nbsp;
                    </P>
                    <Plus>En savoir plus&nbsp;:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/seins/reconstruction-mammaire/">
                              Reconstruction mammaire
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/seins/retirer-implants-mammaires/">
                              Retirer ses implants mammaires
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "redessiner-sa-silhouette" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/redessiner-sa-silhouette.jpg"
                      alt="Redessiner sa silhouette"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Redessiner sa silhouette</H3>

                    <P>
                      Pour vous accompagner dans le traitement de suppression
                      des graisses et de tonification de l'architecture de votre
                      corps, le cabinet du Dr Kron propose une{" "}
                      <Link to="/silhouette/consultation-diagnostic/">
                        pré-consultation diagnostic silhouette
                      </Link>{" "}
                      lors de laquelle vous serez guidé entre les différents
                      traitements qui s’offrent à vous afin remodeler et affiner
                      votre silhouette.
                    </P>

                    <FlexIndication>
                      <Half>
                        <H4>Traitement chirurgicaux</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/silhouette/bodylift/">
                              Bodylift
                            </StyledLink>
                          </Li>

                          <Li>
                            <StyledLink to="/silhouette/implants-fessiers/">
                              Implants fessiers
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/lipoaspiration/">
                              Lipoaspiration
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/chirurgie-esthetique-sous-anesthesie-locale/#liposuccion-douce">
                              Lipoaspiration douche (anesthésie locale)
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/jambes/lipostructure-mollet/">
                              Lipostructure des mollets
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/mommy-makeover/">
                              Mommy makeover
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/plastie-abdominale/">
                              Plastie abdominale
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/remodelage-fesses/">
                              Plastie des bras
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/jambes/protheses-mollets/">
                              Prothèses de mollets
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Techniques médicales</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/silhouette/emsculpt/">
                              EMSculpt
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/xbody-sculpter-raffermir-son-corps/">
                              XBody
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/cryolipolyse-coolsculpting/">
                              CoolSculpting
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/onda-coolwaves/">
                              ONDA Coolwaves
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "perdre-masse-graisseuse" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/perdre-masse-graisseuse.jpg"
                      alt="Perdre de la masse graisseuse"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Perdre de la masse graisseuse</H3>
                    <P>
                      Pendant longtemps, la lipoaspiration était la technique de
                      chirurgie esthétique de référence pour supprimer les amas
                      graisseux disgracieux qui résistent à la pratique sportive
                      ainsi qu’aux régimes. Il existe désormais des techniques
                      de médecine esthétique comme Keybody-Lipo, EMSculpt et la
                      cryolipolyse pour amincir la silhouette.
                    </P>
                    <P>
                      Pour vous accompagner dans le traitement de suppression
                      des graisses et de tonification de l'architecture de votre
                      corps, le cabinet du Dr Kron propose une{" "}
                      <Link to="/silhouette/consultation-diagnostic/">
                        pré-consultation diagnostic silhouette
                      </Link>{" "}
                      lors de laquelle vous serez guidé entre les différents
                      traitements qui s’offrent à vous afin remodeler et affiner
                      votre silhouette.
                    </P>
                    <FlexIndication>
                      <Half>
                        <H4>Techniques chirurgicales</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/silhouette/lipoaspiration/">
                              Lipoaspiration
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/chirurgie-esthetique-sous-anesthesie-locale/#liposuccion-douce">
                              Lipoaspiration douche (anesthésie locale)
                            </StyledLink>
                          </Li>

                          <Li>
                            <StyledLink to="/silhouette/liposuccion-culotte-de-cheval/">
                              Liposuccion de la culotte de cheval
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/bodylift/">
                              Bodylift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/jambes/lipoaspiration-mollets/">
                              Lipoaspiration des mollets
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Techniques médicales</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/silhouette/cryolipolyse-coolsculpting/">
                              Cryolypolyse avec CoolSculpting
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/emsculpt/">
                              EMSculpt
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/keybody-lipo/">
                              Keybody-Lipo
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/keybody-cellulite/">
                              Keybody-Cellulite
                            </StyledLink>
                          </Li>

                          <Li>
                            <StyledLink to="/silhouette/phototherapie-dynamique/">
                              Photothérapie dynamique
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/onda-coolwaves/">
                              ONDA Coolwaves
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/xbody-sculpter-raffermir-son-corps/">
                              X-Body
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "affiner-jambes" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/affiner-jambes.jpg" alt="Affiner mes jambes" />
                  </IndicationImage>

                  <Indication>
                    <H3>Affiner mes jambes</H3>
                    <P>
                      Pour affiner les jambes et supprimer les amas graisseux
                      localisés, la lipoaspiration des cuisses et/ou des mollet
                      constitue l’intervention chirurgicale la plus adapté. Si
                      la présence de tissus adipeux est accompagnée d’un
                      relâchement significatif de la peau, notamment au niveau
                      de la face interne des cuisses, une lipoaspiration peut
                      être accompagné d’un lifting des cuisses.
                    </P>
                    <P>
                      De nouvelles techniques de médecine esthétiques permettent
                      également d’affiner les jambes en supprimant les graisses
                      et en sculptant musculaire les jambes.
                      <br />
                      &nbsp;
                    </P>
                    <FlexIndication>
                      <Half>
                        <H4>Techniques chirurgicales</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/jambes/lipoaspiration-mollets/">
                              Lipoaspiration des mollets
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/jambes/lifting-des-cuisses/">
                              Lifting des cuisses
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Techniques médicales</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/silhouette/cryolipolyse-coolsculpting/">
                              Cryolipolyse avec coolsculpting
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/keybody-lipo/">
                              Keybody-Lipo
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/onda-coolwaves/">
                              ONDA Coolwaves
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/phototherapie-dynamique/">
                              Phototherapie dynamique
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/xbody-sculpter-raffermir-son-corps/">
                              X-Body
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "sculpter-jambes" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/sculpter-jambes.jpg"
                      alt="Sculpter mes jambes"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Sculpter mes jambes</H3>
                    <P>
                      Une lipostructure de mollet est un opération de chirurgie
                      esthétique particulièrement indiquée pour combler un
                      défaut de galbe des jambes au niveau des mollets. Une
                      accentuation durable du relief des mollets est également
                      possible avec la mise en place d'un implant prothétique.
                    </P>
                    <P>
                      Il existe également des traitements médicaux de sculpting
                      musculaire comme Keybody-Lipo, X-Body ou qui permettent
                      d'obtenir de très bons résultats sur le galbe des jambes.
                      <br />
                      &nbsp;
                    </P>
                    <FlexIndication>
                      <Half>
                        <H4>Techniques chirurgicales</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/jambes/lifting-des-cuisses/">
                              Lifting des cuisses
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/jambes/lipostructure-mollet/">
                              Lipostructure des mollets
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/jambes/protheses-mollets/">
                              Prothèses mollets
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Techniques médicales</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/silhouette/keybody-lipo/">
                              Keybody Lipo
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/xbody-sculpter-raffermir-son-corps/">
                              XBody
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "cellulite" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/cellulite.jpg" alt="Éliminer la cellulite" />
                  </IndicationImage>

                  <Indication>
                    <H3>Éliminer la cellulite</H3>
                    <P>
                      La cellulite touche de nombreuses femmes, quel que soit
                      leur âge, leur taille ou leur poids. La «&nbsp;peau
                      d’orange&nbsp;» est difficile à éliminer malgré un régime
                      alimentaire équilibré, une pratique sportive régulière ou
                      le recourt régulier à des massages ou des crèmes
                      anti-cellulite.
                    </P>
                    <P>
                      Pour éliminer définitivement la cellulite, il existe des
                      traitements médicaux efficaces qui peuvent être combinés
                      pour obtenir le meilleur résultat possible. Parmi les
                      traitements les plus efficace pour éliminer la cellulite,
                      on trouve ONDA Coolwaves, la cryolipolyse avec
                      Coolsculpting qui peuvent être associé dans le cade du
                      protocole combiné Keybody-Cellulite.
                      <br />
                      &nbsp;
                    </P>
                    <Plus>En savoir plus&nbsp;:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/silhouette/keybody-cellulite/">
                              Keybody-Cellulite
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/silhouette/onda-coolwaves/">
                              ONDA Coolwaves
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "terne" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/terne.jpg"
                      alt="Ma peau est terne et fatiguée"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Ma peau est terne et fatiguée</H3>
                    <P>
                      Rides et ridules, cicatrices d’acné, vergetures, perte
                      d’élasticité, taches pigmentaires, tumeurs bénignes,
                      points noirs, peaux sèches, relâchées ou sujettes aux
                      inflammations … La peau est la partie du corps qui agit
                      comme une barrière avec l’extérieur et donc l’une des plus
                      sensibles aux agressions de l’environnement ainsi qu’au
                      passage du temps.
                    </P>
                    <P>
                      Les traitements esthétiques de la peau ont beaucoup évolué
                      ces dernières années et proposent des résultats tout à
                      fait significatifs sur de nombreuses indications. Pour
                      vous aider à faire le point sur les différentes techniques
                      existantes, le Dr Kron et son équipe proposent une{" "}
                      <Link to="/visage/consultation-diagnostic/">
                        pré-consultation diagnostic de l’état de votre peau
                      </Link>
                      .
                    </P>

                    <Plus>En savoir plus&nbsp;:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/visage/carboxytherapie/">
                              Carboxythérapie
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/hydrafacial/">
                              HydraFacial
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/laser-icon-correction-imperfections/">
                              Laser Icon
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/peeling-bioretivalisant-prx-t33/">
                              Peeling biorevitalisant
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/visage/peeling-combine/">
                              Peeling combiné
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/PRP-plasma-riche-plaquettes/">
                              Plasma Riche en Plaquettes
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/skinbooster/">
                              Skinbooster
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "relachee" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/relachee.jpg" alt="Ma peau est relâchée" />
                  </IndicationImage>

                  <Indication>
                    <H3>Ma peau est relâchée</H3>
                    <P>
                      La manifestation des premiers signes du vieillissement
                      n’est pas liée à l’âge, car ils apparaissent dès l’âge de
                      20 ans quand les teneurs en collagène et élastine, des
                      protéines donnant à la peau sa structure, commencent à
                      décroître. Vous commencerez à noter une perte de fermeté
                      de la peau. Les premières rides se manifesteront. Plus le
                      temps passera, plus l’effet sera prononcé.
                    </P>
                    <P>
                      Les plis et rides font partie du processus de
                      vieillissement, mais cela ne veut pas dire qu’il n’existe
                      pas de solution. Lorsque la quantité de collagène baisse
                      avec le temps, la peau perd de son élasticité, et les
                      rides apparaissent.
                    </P>

                    <FlexIndication>
                      <Half>
                        <H4>Traitement médicaux</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/visage/ellanse/">
                              ELLANSÉ®
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/mesolift-nctf/">
                              Mesolift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/fils-tenseurs-silhouette-soft/">
                              Fils tenseurs
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/actualites/sisthaema/">
                              Sisthaema
                            </StyledLink>
                          </Li>

                          <Li>
                            <StyledLink to="/visage/skinbooster/">
                              Skinbooster
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/laser-icon-correction-imperfections/">
                              Laser Icon
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/universkin/">
                              Universkin
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Traitement chirurgicaux</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/silhouette/bodylift/">
                              Bodylift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/bras/lifting-plastie/">
                              Lifting des bras
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/jambes/lifting-des-cuisses/">
                              Lifting des cuisses
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/regard/lifting-du-front/">
                              Lifting du front
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/lifting-visage-paris/">
                              Lifting du visage LVPA
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/lifting-cervico-facial/">
                              Lifting cervico-facial
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/cernes/lifting-malaire-cernes-creux/">
                              Lifting malaire
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/silhouette/mommy-makeover/">
                              Mommy makeover
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "rides" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/rides.jpg" alt="Ma peau est ridée" />
                  </IndicationImage>

                  <Indication>
                    <H3>Ma peau est ridée</H3>
                    <P>
                      Les techniques de médecine et de chirurgie esthétique
                      proposent plusieurs types de traitements qui ont fait leur
                      preuve dans la suppression ou l’atténuation des rides et
                      ridules.
                    </P>
                    <P>
                      Dans le domaine de la médecine esthétique, on trouve
                      notamment l’injection de produits de comblement (acide
                      hyaluronique), l’inhibition de certains muscles à
                      l’origine des rides d’expression (botox) ou stimulation de
                      la collagènese par l’organisme offerte par le laser, la
                      radiofréquence ou les peelings.
                    </P>
                    <P>
                      Dans le domaine de la chirurgie esthétique, les liftings
                      (notamment le lifting du visage LVPA mis au point par le
                      Dr Cédric Kron) corrigent les rides en remettant en
                      tension la peau.
                      <br />
                      &nbsp;
                    </P>
                    <FlexIndication>
                      <Half>
                        <H4>Traitement médicaux</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/acide-hyaluronique/">
                              Acide hyaluronique
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/comblement-rides-front/">
                              Comblement des rides du front
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/supprimer-rides-front/">
                              Injection de botox
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/regard/patte-d-oie-botox/">
                              Botox : Supprimer les pattes d’oie
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/supprimer-rides-front/">
                              Botox : Rides du front
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/peeling-rides-patte-d-oie/">
                              Peeling : Rides de la patte d’oie
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/regard/plexr/">Plexr</StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/laser-icon-correction-imperfections/">
                              Laser Icon
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Traitement chirurgicaux</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/chirurgie-esthetique-sous-anesthesie-locale/#mini-lift">
                              Mini-Lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/lifting-visage-paris/">
                              Lifting du visage LVPA
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/lifting-cervico-facial/">
                              Lifting cervico-facial
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/regard/lifting-du-front/">
                              Lifting du front
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "cicatrices" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/cicatrices.jpg"
                      alt="J’ai des cicatrices ou des séquelles d’acné"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>J’ai des cicatrices ou des séquelles d’acné</H3>
                    <P>
                      Une cicatrice correspond à la partie visible d’une lésion
                      du derme. Elle fait partie intégrante du processus de
                      guérison des tissus cutanés. Une cicatrice peut être issue
                      d’un traumatisme (blessure) ou d’une opération
                      chirurgicale (suite à une incision du derme). Toutes les
                      lésions de la peau entrainent des cicatrices à l’exception
                      des lésions les plus superficielles, qui ne touchent que
                      l’épiderme.
                    </P>
                    <P>
                      Des traitements de médecine esthétique comme la
                      Radiofréquence, le laser Icon, LaseMD Ultra, Keybody-Skin
                      ou PlexR permettent d'obtenir de bons résultats pour
                      atténuer certains types de cicatrices, notamment sur les
                      cicatrices d'acné.
                      <br />
                      &nbsp;
                    </P>
                    <Plus>En savoir plus&nbsp;:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/peau/correction-cicatrices/">
                              Chirurgie des cicatrices
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/laser-icon-correction-imperfections/">
                              Laser Icon
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/universkin/">
                              Universkin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/visage/peeling-combine/">
                              Peeling combiné
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/peeling-bioretivalisant-prx-t33/">
                              Peeling biorevitalisant
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "taches" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/taches.jpg"
                      alt="J’ai des tâches ou des lésions pigmentaires"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>J’ai des tâches ou des lésions pigmentaires</H3>
                    <P>
                      Les dernières générations de traitements médicaux de la
                      peau permettent de traiter efficacement les taches et
                      lésions pigmentaires (mélasma, héliodermie, lentigos,
                      kératose actinique, tâches de vieillesse, éphélides,
                      mélasma, les irrégularités superficielles de la peau
                      (comme les cicatrices de varicelle ou d’acné) tout en
                      redonnant à la peau tout son éclat. Parmi ces traitements,
                      on trouve notamment LaseMD Ultra, ONDA Coolwaves ou Plexr.
                    </P>

                    <P>
                      Pour un résultat encore plus significatif, le Dr Cédric
                      Kron a mis en place le protocole Keybody-Skin Plus® qui
                      permet à la fois de corriger le relâchement de l’ovale du
                      visage, de régénérer en profondeur la peau et de traiter
                      les taches et lésions pigmentaires.
                      <br />
                      &nbsp;
                    </P>
                    <Plus>En savoir plus&nbsp;:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/visage/couperose-rosacee-erythrose-laser/">
                              Couperose, rosacée et érythrose
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/peeling-combine/">
                              Peeling combiné
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/peeling-bioretivalisant-prx-t33/">
                              Peeling biorevitalisant
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/skinbooster/">
                              Skinbooster
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/supprimer-vergetures/">
                              Traitement des vergetures
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/peau/laser-icon-correction-imperfections/">
                              Laser Icon
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/visage/universkin/">
                              Universkin : Cosmétique médicale
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/peau/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              <Back onClick={() => this.changeStep(1)}>&lt; Retour</Back>
            </Wrapper>
          )}
        </MultiStep>
      </div>
    );
  }
}

const Wrapper = styled.div`
  padding: 30px 4px 20px;
  min-height: 735px;
`;

const MultiStep = styled.div`
  width: 1100px;
  max-width: 100%;
  margin: 0 auto 120px;
  position: relative;
`;

const Step = styled.div`
  cursor: default;
  text-align: center;
  font-size: 1.2em;
  width: 100%;
  margin-bottom: 45px;
  font-weight: 600;
  color: #3c4d68;
  @media (max-width: 678px) {
    margin-bottom: 60px;
  }
`;

const StepNumber = styled.div`
  font-size: 0.65em;
  color: white;
  background-color: #3c4d68;
  width: 88px;
  margin: 0 auto;
  border-radius: 18px;
  font-style: normal;
  margin-bottom: 10px;
`;

const CardWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  grid-template-row: 2fr 2fr 2fr 2fr;

  @media (max-width: 1000px) {
    grid-template-columns: 33% 33% 33%;
    grid-template-row: 2fr 2fr 2fr;
  }
  @media (max-width: 678px) {
    grid-template-columns: 50% 50%;
    grid-template-row: 2fr 2fr;
  }
`;

const Card = styled.button`
  position: relative;
  width: 100%;
  border-radius: 8px;
  border: none;
  padding: 0.8em;
  background-color: white;
  transition: all 0.3s ease-in-out;
  transform: scale(1);
  :hover {
    transition: all 0.3s ease-in-out;
    transform: scale(1.02);
  }
  @media (max-width: 678px) {
    padding: 0.3em;
  }
`;

const Img = styled.img`
  max-width: 100%;
  filter: grayscale(100%);
  border-radius: 8px;
  :hover {
    filter: grayscale(0%);
  }
  @media (max-width: 678px) {
    filter: none;
  }
  @media (min-width: 900px) {
    width: 260px;
    height: 260px;
  }
`;

const CardTitle = styled.div`
  position: absolute;
  bottom: 30px;
  text-align: center;
  background-color: white;
  width: 90%;
  font-size: 1.26em;
  font-weight: 700;
  color: rgb(60, 77, 104);
  padding: 8px;
  letter-spacing: 0.03em;
  @media (max-width: 678px) {
    font-size: 1.1em;
    width: 92%;
    padding: 4px;
    bottom: 17px;
  }
`;

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 678px) {
    display: block;
    padding: 0 10px;
  }
`;

const FlexIndication = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 678px) {
    display: block;
  }
`;

const IndicationImage = styled.div`
  width: 25%;
  padding: 11px 35px 10px 10px;
  @media (max-width: 678px) {
    width: 100%;
    padding: 0;
  }
`;

const Indication = styled.div`
  width: 75%;
  padding: 0 1em 0 1.5em;
  @media (max-width: 678px) {
    width: 100%;
    padding: 0;
  }
`;

const Image = styled.img`
  border-radius: 8px;
  max-width: 100%;
`;

const H3 = styled.h3`
  font-size: 2em;
  font-weight: 700;
  margin: 0.5em 0 0.65em;
  @media (max-width: 678px) {
    text-align: center;
    font-size: 1.55em;
    line-height: 1.28em;
    margin: 0.25em 0 0.35em;
  }
`;

const P = styled.p`
  font-weight: 400;
  font-size: 1.01em;
  line-height: 1.62em;
  @media (max-width: 678px) {
    font-size: 1.02em;
    line-height: 1.56em;
  }
`;

const Half = styled.div`
  padding-top: 5px;
  flex: 50%;
  @media (max-width: 678px) {
    width: 100%;

    padding-top: 0;
  }
`;

const H4 = styled.h4`
  text-align: center;
  font-size: 1.1em;
  letter-spacing: 0.02em;
  font-weight: 700;
  background-color: #3c4d68;
  color: white;
  display: inline-block;
  margin: 0.2 auto 0.5em;
  border: 1px solid #3c4d68;
  border-radius: 6px;
  padding: 0.15em 1em;
  @media (max-width: 678px) {
    margin: 0 auto;
    margin-bottom: 12px;
    margin-top: 10px;
  }
`;

const Plus = styled.p`
  color: #3c4d68;
  font-size: 1.3em;
  font-weight: 700;
  margin-top: 5px;
  margin-bottom: 5px;
  @media (max-width: 678px) {
    margin-bottom: 12px;
  }
`;

const Ul = styled.ul`
  margin: 0 !important;
  list-style: none;
  @media (max-width: 678px) {
  }
`;

const Li = styled.li`
  font-size: 1em;
  margin-bottom: 0.3em;
  :before {
    content: "➔ ";
    color: #3c4d68;
    font-size: 0.8em;
    font-weight: bold;
    display: inline-block;
    width: 2em;
    margin-left: 0em;
  }
  @media (max-width: 678px) {
    :before {
    }
  }
`;

const StyledLink = styled(Link)`
  border-bottom: none;
`;

const Back = styled.button`
  position: absolute;
  top: 100px;
  color: white;
  background-color: #3c4d68;
  border: 1px solid #3c4d68;
  padding: 0.5em 1.5em;
  margin-left: 10px;
  display: block;
  border-radius: 7px;
  text-align: center;
  font-weight: 700;
  width: 150px;
  text-decoration: none;
  letter-spacing: 0.03em;
  transition: all 0.3s ease-in-out 0s;
  hover {
    background-color: white;
    color: #3c4d68;
    transition: all 0.3s ease-in-out 0s;
  }
  @media (max-width: 678px) {
    margin-left: 3px;
    padding: 0.5em 0.75em;
    width: 90px;
  }
`;
